@use 'sass:map';
@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;
  position: relative;
  max-width: 100%; // DO NOT REMOVE - fixes FLUID Content overflow issue
  overflow: clip; // DO NOT REMOVE - fixes FLUID Content overflow issue
  box-sizing: border-box;

  // ==== Root Container Element

  .fluid-page {
    max-width: 100%;
    min-height: 100vh; // Overridden by inline styles
    display: flex;
    position: relative;
  }

  // ==== Main Content Container

  .main-content {
    flex: 1 1 auto;
    min-width: 0; // Fix flexbox overflow
    display: flex;
    flex-direction: column;
    position: relative;
  }

  // ==== Context Bar & Footer Bar Containers

  .context-bar-container,
  .page-footer-container {
    flex: 0 1 auto;
    display: block;
    position: sticky;
  }

  .context-bar-container {
    top: 0;
    z-index: map.get($stacking-context, page-context-bar);
  }

  .page-footer-container {
    bottom: 0;
    z-index: map.get($stacking-context, page-footer);

    &.drop-shadow {
      box-shadow: var(--page-footer-box-shadow);
      clip-path: inset(-100vh 0 0 0); // Constrains box-shadow to top only
    }
  }

  // ==== Sidebar Toggle Button Background Color Override
  // When themeVariant Prop is set, change button BG color for contrast accessibility

  .atmospheric-bg {
    background-color: $liberty-gray-4;

    fluid-sidebar::part(sidebar-expand-toggle) {
      &:not(:hover):not(:focus-visible):not(:active) {
        background-color: white;
      }
    }
  }
}
